const ContactInput = ({
    hint,type='text',height,className,name,
    textarea,oninvalid,error,label,register

}) => {
    return(
        <div className="w-full">
            {
            label&&
            <label
            className="block mb-1 font-medium">
                {label}
            </label>
            }
            <input
            placeholder={hint}
            type={type}
            {...register(name)}
            className={`w-full focus:ring-2 focus:ring-aqua outline-none
                 bg-[#e8e8e8] rounded-[10px] py-3 px-5 placeholder:text-sm ${height} ${className} ${error?'':''}`}
            // required
            // onInvalid={oninvalid}
            />
            {error&&
            <p className="text-[13px] mt-2 text-red-500">
                {error.message}
            </p>
            }
        </div>
    )
}
export default ContactInput